import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Route, ActivatedRoute, Params } from '@angular/router';
import { Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { SystemSelectService } from '../../../system-select/system-select.service';
import { ToolDescriptionService, ToolService, ToolNumberService } from '../../../camtl.service';
import { Tool } from '../../../../../shared/model';
import { CgpTreeviewService } from '../../../../../shared/cgp-treeview/cgp-treeview.service';
import { CgpSnackbarService } from '../../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { CgpConfirmationDialogService } from '../../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpGridComponent } from '../../../../../shared/cgp-grid/cgp-grid.component';
import { RouteValidationService } from "../../../../../shared/route-validation.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-tools',
  templateUrl: './tools.component.html',
  // styleUrls: ['./tools.component.scss']
})
export class ToolsComponent implements OnInit, OnDestroy {

  constructor(
    private service: ToolService,
    private formBuilder: FormBuilder,
    private systemSelectService: SystemSelectService,
    private cgpTreeviewService: CgpTreeviewService,
    private routeParams: ActivatedRoute,
    private cgpSnackbarService: CgpSnackbarService,
    private cgpAlertDialogService: CgpAlertDialogService,
    private cgpConfirmationDialogService: CgpConfirmationDialogService,
    private routeValidationService: RouteValidationService
  ) { }

  private parentType: any;
  private parentName: any;
  private grandParentQuery: string = "";
  private urlEnd: any;

  private toolId: string;
  private dataSource: any;
  private selected: any;
  private parentId: any;
  selectedRowId: any;
  system: any;
  disableActions: boolean = false;
  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent

  private ngUnsubscribe: Subject<void> = new Subject<void>();
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit() {
    var self = this;
    this.systemSelectService.system$
      .subscribe(system => {
        this.system = system;
        if (this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Tools')) {
          this.cgpTreeviewService.dataSource$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(dataSource => this.dataSource = dataSource);
          this.cgpTreeviewService.selected$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(selected => this.selected = selected);
          this.cgpTreeviewService.get();
          this.cgpTreeviewService.getSelected();
        }
        if (this.system && this.system.AllocationStatus !== null && this.system.AllocationStatus.toLowerCase().indexOf("process") !== -1) {
          this.disableActions = true;
        }
        else {
          this.disableActions = false;
        }

      });

    this.systemSelectService.get();

    this.routeParams.params
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((params: Params) => {
        if (this.routeParams.snapshot.params["id"]) {
          this.toolId = this.routeParams.snapshot.params["id"];
        }
        else {
          this.toolId = "";
        }
      });

    this.routeParams.queryParams
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((params: Params) => {
        this.parentId = params["ParentId"];
        if (this.parentId && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Tools') && this.parentId.includes('-')) {
          this.service.read("/" + this.parentId, true)
            .then(function (response) {
              switch (response[0].ToolTypeName.toString()) {
                case "System Layout":
                  self.parentType = "System Layout";
                  self.urlEnd = "SystemLayout"
                  break;
                case "Cell":
                  self.parentType = "Cell";
                  self.urlEnd = "Cells"
                  break;
                case "Station":
                  self.parentType = "Station";
                  self.urlEnd = "Stations"
                default:
                  break;
              }
              self.parentName = response[0].ToolDetail.ToolNumber;
              if (response[0].ParentId !== null) {
                self.grandParentQuery = "?ParentId=" + response[0].ParentId
              }
              else {
                self.grandParentQuery = "";
              }
              self.cgpTreeviewService.setSelected(response[0]);
            })
        }

      })

    this.changeTemplateService();
  }

  setUnassignedRed = (value) => {
    if (value === "N/A") {
      return 'cgp-red';
    }

    return '';
  }

  private columns: any[] = [
    {
      field: "ToolDetail.ToolNumber",
      title: "Tool Number",
    },
    {
      field: "DescriptionDisplay",
      title: "Description"
    },
    {
      field: "TotalHours",
      title: "Total Hours"
    },
    {
      field: "DesignEndDate",
      title: "Design End Date",
      template: {
        type: "date",
        dateFormat: "MM/dd/yyyy"
      }
    },
    {
      field: "DockDate",
      title: "Dock Date",
      template: {
        type: "date",
        dateFormat: "MM/dd/yyyy"
      }
    },
    {
      field: 'LeftCount',
      title: 'LH',
      width: 70
    },
    {
      field: 'RightCount',
      title: 'RH',
      width: 70
    },
    {
      field: 'SingleCount',
      title: 'S',
      width: 70
    },
    {
      field: "Pcbom",
      title: "PCB",
      width: 80,
      template: {
        type: "customStyle",
        setClass: this.setUnassignedRed
      }
    },
    {
      field: "ToolDetail.IsIntegration",
      title: "INT",
      template: {
        type: "boolean",
        onLabel: "True",
        offLabel: "False"
      },
      width: 80
    },
    {
      field: "WireDesign",
      title: "WD",
      width: 80,
      template: {
        type: "customStyle",
        setClass: this.setUnassignedRed
      }
    },
    {
      field: "ToolDetail.IsCanceled",
      title: "CAN",
      template: {
        type: "boolean",
        onLabel: "True",
        offLabel: "False"
      },
      width: 80
    }
  ];

  unassignTool = (e, dataItem: Tool, service, system, callBackInputs) => {
    var self = this;
    this.cgpConfirmationDialogService.showConfirmationDialog({
      title: 'Unassign Tool',
      message: 'Are you sure that you want to unassign this tool?',
      alert: 'danger',
      onYesClick: () => {
        ;
        dataItem.ParentId = null;
        self.service.save(dataItem, false, "", false, false).then(function () {
          self.service.loading.next(false);
          self.cgpSnackbarService.showSnackbar({
            message: 'Tool has been unassigned',
            duration: 2000
          });
          self.grid.refresh(true);
          self.systemSelectService.get();
          self.cgpConfirmationDialogService.closeConfirmationDialog();
        }).catch(function (response) {
          self.service.loading.next(false);;
          this.cgpConfirmationDialogService.closeConfirmationDialog();
          self.cgpAlertDialogService.showAlertDialog({
            title: 'Error',
            message: response._body.replace(/"/g, ''),
            alert: 'danger',
            closeLabel: 'Close',
          })
        });
      },
      onNoClick: () => {
        this.cgpConfirmationDialogService.closeConfirmationDialog();
      }
    })
  }

  private customButtons = [
    {
      id: "unassignTool",
      class: "fa fa-mail-reply",
      title: "Unassign Tool",
      callback: this.unassignTool
    }
  ];

  isDisabled = (id) => {
    switch (id) {
      case "unassignTool":
        return this.disableActions;
      default:
        return false;
    }
  }

  getById = () => {
    if (this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Tools')) {
      return this.service.read("/" + this.toolId, true).then(function (response: Tool[]) {
        for (var i = 0; i < response.length; i++) {
          response[i]["DesignEndDate"] = response[i].ToolDetail.DesignEndDate;
          response[i]["DockDate"] = response[i].ToolDetail.DockDate;
          response[i]["DisplayNumber"] = response[i].ToolDetail.ToolNumber;
          if (response[i].LegacyToolDescription !== null) {
            response[i]["DescriptionDisplay"] = response[i].LegacyToolDescription;
          }
          else {
            response[i]["DescriptionDisplay"] = response[i].ToolDescription;
          }

          if (response[i].ToolDetail.PcBom === null || response[i].ToolDetail.PcBom === "") {
            response[i].ToolDetail.PcBom = "N/A";
          }

          if (response[i].ToolDetail.WireDesign === null || response[i].ToolDetail.WireDesign === "") {
            response[i].ToolDetail.WireDesign = "N/A";
          }

          response[i].Pcbom = response[i].ToolDetail.PcBom;
          response[i].WireDesign = response[i].ToolDetail.WireDesign;
        }

        return response;
      });
    }
  }

  changeTemplateService() {
    if (this.toolId) {
      this.template = {
        controls: {
          add: false,
          edit: false,
          delete: false,
          excel: true,
          width: 65,
          custom: this.customButtons,
          isDisabled: this.isDisabled
        },
        columns: this.columns,
        service: this.service,
        read: this.getById,
        fileName: "tools_detail.xlsx",
        displayField: "DisplayNumber"
      }
    }
  }

  getToolsByParentId = (): Promise<any> => {
    if (
      this.parentId &&
      this.parentId.includes('-') &&
      this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Tools')) {
      return this.service.read("/tools/" + this.parentId, true)
        .then(function (response: Tool[]) {
          for (var i = 0; i < response.length; i++) {
            response[i]["DesignEndDate"] = response[i].ToolDetail.DesignEndDate;
            response[i]["DockDate"] = response[i].ToolDetail.DockDate;
            response[i]["DisplayNumber"] = response[i].ToolDetail.ToolNumber;

            if (response[i].LegacyToolDescription !== null) {
              response[i]["DescriptionDisplay"] = response[i].LegacyToolDescription;
            }
            else {
              response[i]["DescriptionDisplay"] = response[i].ToolDescription;
            }

            if (response[i].ToolDetail.PcBom === null || response[i].ToolDetail.PcBom === "") {
              response[i].ToolDetail.PcBom = "N/A";
            }

            if (response[i].ToolDetail.WireDesign === null || response[i].ToolDetail.WireDesign === "") {
              response[i].ToolDetail.WireDesign = "N/A";
            }

            response[i].Pcbom = response[i].ToolDetail.PcBom;
            response[i].WireDesign = response[i].ToolDetail.WireDesign;
          }
          return response;
        });
    }
  }

  template = {
    controls: {
      add: false,
      edit: false,
      delete: false,
      excel: true,
      width: 65,
      custom: this.customButtons,
      isDisabled: this.isDisabled
    },
    columns: this.columns,
    service: this.service,
    read: this.getToolsByParentId,
    fileName: "tools_detail.xlsx",
    displayField: "DisplayNumber"
  }

}
